import React, { useEffect, useState } from "react";
import { PerfilesSelect } from "./PerfilesSelect";
import { Form } from "antd";
import { useSelector } from "react-redux";

export const PerfilesUsuarioDiv = () => {
  const form = Form.useFormInstance();
  const { activeUsuario } = useSelector((state) => state.usuario);
  let accesosusuario = Form.useWatch("accesosusuario", form);

  const handleChangePerfil = (value, field) => {
    // const perfilesIniciales = activeUsuario?.perfilesusuario || [];

    // const perfil_add = field?.filter(
    //   (x) => !perfilesIniciales.some((y) => x.value === y.id)
    // );

    // if (Array.isArray(perfil_add) && perfil_add.length > 0) {
    //   perfil_add?.forEach((row) => {
    //     const _accesos = row?.accesosgrupo?.map((x) => x.ruta);
    //     accesosusuario = [...accesosusuario, ..._accesos];
    //   });
    // } else {
    let accesosusuario = [];
    field?.forEach((row) => {
      const _accesos = row?.accesosgrupo?.map((x) => x.ruta);
      accesosusuario = [...accesosusuario, ..._accesos];
    });
    // }

    form.setFieldsValue({ accesosusuario });
  };
  return (
    <Form.Item label="Perfiles" name="perfilesusuario">
      <PerfilesSelect
        placeholder="Seleccione perfiles"
        onChange={handleChangePerfil}
      />
    </Form.Item>
  );
};
